import DeliveryItem from './DeliveryItem';

export default DeliveryItem;
